import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    paddingTop: 5,
    display: 'flex',
    flexDirection: 'column'
  },
  destinationHeader: {
    paddingLeft: 3,
    marginBottom: 3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  icon: {
    marginRight: 4,
    fontSize: 18,
    color: theme.palette.grey[500],
    display: 'flex'
  },
  title: {
    color: theme.palette.grey[500],
    fontSize: 16,
    display: 'flex'
  },
  destinationInput: {
    border: 'none',
    outline: 'none',
    '&:focus': {
      outline: 'none'
    },
    fontSize: 16,
    paddingTop: 5,
    padding: '6px 0 7px',
    maxHeight: 250
  },
  destinationAutoComplete: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
export default useStyles
